export default __webpack_public_path__ + "static/media/karmayogi-volunteer-pac3.d673cffe.jpeg";